import { Swiper } from 'swiper';
import { A11y, Navigation } from 'swiper/modules';

const sliders = document.querySelectorAll('.block-trip-accommodations .swiper');

if (sliders.length > 0) {
	sliders.forEach((slider) => {
		const settings = {
			loop: false,
			grabCursor: true,
			slidesPerView: 1,
			spaceBetween: 16,
			centeredSlides: false,
			modules: [A11y, Navigation],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: slider
					.closest('.block-trip-accommodations')
					.querySelector('.swiper-button-prev'),
				nextEl: slider
					.closest('.block-trip-accommodations')
					.querySelector('.swiper-button-next'),
			},
			breakpoints: {
				576: {
					spaceBetween: 24,
				},
				768: {
					spaceBetween: 32,
				},
			},
		};

		new Swiper(slider, settings);
	});
}
